const CrossIcon = () => {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="none"
                  viewBox="0 0 16 16"
            >
                  <path
                        stroke="#100F14"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M5.17 10.829l5.658-5.657M10.828 10.828L5.17 5.171"
                  ></path>
            </svg>
      );
};

export default CrossIcon;
